// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  width: var(--sidebar-width);
  background-color: #ffffff;
  height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 25px 0;
  box-sizing: border-box;
  position: fixed;
  left: 0;
  top: 0;
  border-right: 1px solid #f3f4f6;
  transition: transform 0.3s ease-in-out;
  z-index: 999;
}

.sidebar-logo {
  padding: 0 25px;
  margin-bottom: 40px;
 
  flex-shrink: 0;
}

.sidebar-logo img {
  height: 35px;
}

 
.sidebar-nav {
  flex-grow: 1;
 
  overflow-y: auto;
}

 
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}
.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;  
}
.sidebar-nav::-webkit-scrollbar-thumb {
  background-color: #d1d5db;  
  border-radius: 10px;
}
.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background-color: #9ca3af; 
}
 


.sidebar-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.sidebar-nav li a {
  display: flex;
  align-items: center;
  padding: 12px 25px;
  text-decoration: none;
  color: #174078;
  font-weight: 500;
  font-size: 16px;
  margin: 0 15px 4px 15px;
  border-radius: 8px;
  transition: background-color 0.2s, color 0.2s;
}

.sidebar-nav li a:hover {
  background-color: #FEF3F2;
  color: #F97316;
}

.sidebar-nav li.active a {
  background-color: #FEF3F2;
  color: #F97316;
}

.sidebar-nav li a img {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.nav-icon-svg {
  width: 20px;
  height: 20px;
  margin-right: 15px;
  flex-shrink: 0;
  color: #f97316;
  transition: color 0.2s;
}

.sidebar-nav li a:hover .nav-icon-svg,
.sidebar-nav li.active a .nav-icon-svg {
  color: #f97316;
}

/* Collapsible shop group */
.sidebar-group {
  margin: 4px 0 8px;
}

.sidebar-group-toggle {
  display: flex;
  align-items: center;
  width: calc(100% - 30px);
  margin: 0 15px 4px;
  padding: 12px 25px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: #174078;
  font-weight: 500;
  font-size: 16px;
  font-family: inherit;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;
  text-align: left;
}

.sidebar-group-toggle span {
  flex: 1 1;
}

.sidebar-group-toggle:hover,
.sidebar-group.active-group .sidebar-group-toggle {
  background-color: #fef3f2;
  color: #f97316;
}

.sidebar-group-toggle:hover .nav-icon-svg,
.sidebar-group.active-group .sidebar-group-toggle .nav-icon-svg {
  color: #f97316;
}

.sidebar-group-chevron {
  width: 16px;
  height: 16px;
  transition: transform 0.2s;
  flex-shrink: 0;
}

.sidebar-group-toggle.open .sidebar-group-chevron {
  transform: rotate(180deg);
}

.sidebar-subnav {
  list-style: none;
  padding: 0;
  margin: 2px 15px 6px 40px;
  border-left: 2px solid #f3f4f6;
}

.sidebar-subnav li a {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  margin: 0 0 2px 0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
}

.sidebar-subnav li.active a {
  background-color: #fef3f2;
  color: #f97316;
}

.sidebar-divider {
  border: none;
  height: 1px;
  background-color: #E5E7EB;
  margin: 20px 25px;
}

.sidebar-logout {
  padding: 0 15px;
   
  flex-shrink: 0;
}

.sidebar-logout a {
  display: flex;
  align-items: center;
  padding: 12px 25px;
  text-decoration: none;
  color: #6B7280;
  font-weight: 500;
  font-size: 16px;
  border-radius: 8px;
}

.sidebar-logout a:hover {
  background-color: #FEF3F2;
  color: #F97316;
}

.sidebar-logout a img {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

@media (max-width: 768px) {
  .sidebar {
    width: var(--sidebar-width);
    transform: translateX(-100%);
    position: fixed;
  }

  .sidebar.open {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/compoonents/Sidebar/Sidebar.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,MAAM;EACN,+BAA+B;EAC/B,sCAAsC;EACtC,YAAY;AACd;;AAEA;EACE,eAAe;EACf,mBAAmB;;EAEnB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,YAAY;;EAEZ,gBAAgB;AAClB;;;AAGA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;;;AAIA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;;EAEf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".sidebar {\n  width: var(--sidebar-width);\n  background-color: #ffffff;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  padding: 25px 0;\n  box-sizing: border-box;\n  position: fixed;\n  left: 0;\n  top: 0;\n  border-right: 1px solid #f3f4f6;\n  transition: transform 0.3s ease-in-out;\n  z-index: 999;\n}\n\n.sidebar-logo {\n  padding: 0 25px;\n  margin-bottom: 40px;\n \n  flex-shrink: 0;\n}\n\n.sidebar-logo img {\n  height: 35px;\n}\n\n \n.sidebar-nav {\n  flex-grow: 1;\n \n  overflow-y: auto;\n}\n\n \n.sidebar-nav::-webkit-scrollbar {\n  width: 6px;\n}\n.sidebar-nav::-webkit-scrollbar-track {\n  background: transparent;  \n}\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;  \n  border-radius: 10px;\n}\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background-color: #9ca3af; \n}\n \n\n\n.sidebar-nav ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.sidebar-nav li a {\n  display: flex;\n  align-items: center;\n  padding: 12px 25px;\n  text-decoration: none;\n  color: #174078;\n  font-weight: 500;\n  font-size: 16px;\n  margin: 0 15px 4px 15px;\n  border-radius: 8px;\n  transition: background-color 0.2s, color 0.2s;\n}\n\n.sidebar-nav li a:hover {\n  background-color: #FEF3F2;\n  color: #F97316;\n}\n\n.sidebar-nav li.active a {\n  background-color: #FEF3F2;\n  color: #F97316;\n}\n\n.sidebar-nav li a img {\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n}\n\n.nav-icon-svg {\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n  flex-shrink: 0;\n  color: #f97316;\n  transition: color 0.2s;\n}\n\n.sidebar-nav li a:hover .nav-icon-svg,\n.sidebar-nav li.active a .nav-icon-svg {\n  color: #f97316;\n}\n\n/* Collapsible shop group */\n.sidebar-group {\n  margin: 4px 0 8px;\n}\n\n.sidebar-group-toggle {\n  display: flex;\n  align-items: center;\n  width: calc(100% - 30px);\n  margin: 0 15px 4px;\n  padding: 12px 25px;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  color: #174078;\n  font-weight: 500;\n  font-size: 16px;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background-color 0.2s, color 0.2s;\n  text-align: left;\n}\n\n.sidebar-group-toggle span {\n  flex: 1;\n}\n\n.sidebar-group-toggle:hover,\n.sidebar-group.active-group .sidebar-group-toggle {\n  background-color: #fef3f2;\n  color: #f97316;\n}\n\n.sidebar-group-toggle:hover .nav-icon-svg,\n.sidebar-group.active-group .sidebar-group-toggle .nav-icon-svg {\n  color: #f97316;\n}\n\n.sidebar-group-chevron {\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s;\n  flex-shrink: 0;\n}\n\n.sidebar-group-toggle.open .sidebar-group-chevron {\n  transform: rotate(180deg);\n}\n\n.sidebar-subnav {\n  list-style: none;\n  padding: 0;\n  margin: 2px 15px 6px 40px;\n  border-left: 2px solid #f3f4f6;\n}\n\n.sidebar-subnav li a {\n  display: flex;\n  align-items: center;\n  padding: 10px 16px;\n  margin: 0 0 2px 0;\n  border-radius: 8px;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.sidebar-subnav li.active a {\n  background-color: #fef3f2;\n  color: #f97316;\n}\n\n.sidebar-divider {\n  border: none;\n  height: 1px;\n  background-color: #E5E7EB;\n  margin: 20px 25px;\n}\n\n.sidebar-logout {\n  padding: 0 15px;\n   \n  flex-shrink: 0;\n}\n\n.sidebar-logout a {\n  display: flex;\n  align-items: center;\n  padding: 12px 25px;\n  text-decoration: none;\n  color: #6B7280;\n  font-weight: 500;\n  font-size: 16px;\n  border-radius: 8px;\n}\n\n.sidebar-logout a:hover {\n  background-color: #FEF3F2;\n  color: #F97316;\n}\n\n.sidebar-logout a img {\n  width: 20px;\n  height: 20px;\n  margin-right: 15px;\n}\n\n@media (max-width: 768px) {\n  .sidebar {\n    width: var(--sidebar-width);\n    transform: translateX(-100%);\n    position: fixed;\n  }\n\n  .sidebar.open {\n    transform: translateX(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
